// src/routes/domains/client/index.ts
import { clientRoutes } from './client.routes.tsx';
import type { AppRoute } from '../../core/types';

export const loadClientRoutes = (): Promise<AppRoute[]> => Promise.resolve(clientRoutes);